import { useEffect, useState } from 'react';
import { getExploreOrg } from '../../apis/oragnisations/organisation';
import Loader from '../../ui/Loader';

import SummaryCard from '../../ui/SummaryCard';
import BackButton from '../../assets/icons/BackButton';
import Heading from '../../ui/Heading';
import { useNavigate } from 'react-router-dom';
import SummaryCardInAll from './SummaryCardInAll';
import NoDataAvailable from '../../ui/NoDataAvailable';
import { useLoadingState } from '../../hooks/useLoader';

function AllOrganizations() {
    const navigate = useNavigate();
    const [impactOrganizations, setImpactOrganizations] = useState([]);
    const { loading, startLoading, stopLoading } = useLoadingState();
    useEffect(function () {
        const fetchData = async () => {
            try {
                startLoading();
                const data = await getExploreOrg(1000);

                setImpactOrganizations(data);
            } catch (error) {
                console.log(error);
            }
            stopLoading();
        };
        fetchData();
    }, []);

    return (
        <>
            <div className="w-[50%] mb-6">
                <div className="flex items-center">
                    <BackButton onClick={() => navigate(-1)} />
                    <Heading type={'pageHeading'} className={'text-textPrimary ml-3'}>
                        Explore Impact Organizations
                    </Heading>
                </div>
                <p className="mt-2 text-textSecondary">
                    Discover Impact Organizations that match your interest and skill. Click on any of organizations of
                    your interest and express a desire to join them, it is that simple to get started on an impactful
                    career.
                </p>
            </div>
            <div className={`grid grid-cols-2 gap-6`}>
                {loading ? (
                    <div className="h-40 col-span-2 bg-grayBgNormal flex items-center justify-center">
                        <Loader />
                    </div>
                ) : (
                    <>
                        {impactOrganizations.length > 0 ? (
                            impactOrganizations.map((organization) => (
                                <SummaryCardInAll
                                    redirectTo={() => navigate(`/organizations/${organization._id}`)}
                                    className="shadow-md"
                                    key={organization.name + organization.tagline}
                                    organization={organization}
                                />
                            ))
                        ) : (
                            <div className="h-auto min-h-40 col-span-2 bg-grayBgNormal flex items-center justify-center">
                                <NoDataAvailable marginTop="mt-8" imgClassName="w-36" className="mb-8" />
                            </div>
                        )}
                    </>
                )}
            </div>
        </>
    );
}

export default AllOrganizations;
